import m from 'mithril';
import { MithrilTsxComponent } from 'mithril-tsx-component';
import { pause, singleton } from 'oj-promise-utils';
import { cleanString, throttle } from 'oj-utils';
import * as Configuration from "../../state/configuration";
import * as ProRail from "../../state/data/prorail";
import { IDX } from "../../state/data/prorail";
import state, { pmMap, smMap } from '../../state/state';
import { getText, getTextFixed, languages } from "../../state/translations";
import { addRecentSearch, getRecentSearches, removeRecentSearch } from "../../state/localstrorage";
import { getBoundingClientRectFrom } from "../../utils/dom";
import { createFuzzySearch, normalizeText } from "../../utils/fuzzy";
import { getAsset } from '../../utils/utils';
import { Button } from '../button/button';
import { dialog } from "../dialog/dialog";
import { openTooltipDialog } from "../dialog/tooltipDialog";
import { sharedProductUtils } from "../productDetail/productDetail";
import { Svg } from "../svg/svg";
import { railProContent } from '../prorail/prorail';
import './header.scss';
import { isZentrakResult, ZENTRAK_LOGO } from '../../state/zentrak';
const partListDialogWidth = 500;
const partListDialogHeight = 550;
const maxSearchResults = 1000;
let appEl;
// diacritic/case-insensitive and ignores separators (spaces, dashes, dots, ...) so e.g. "pr-123" matches "PR 123"
const normalize = (s) => s ? normalizeText(s).replace(/[^a-z0-9]+/g, "") : "";
class ResultItem extends MithrilTsxComponent {
    highlightRanges(text, ranges) {
        if (!ranges || ranges.length === 0)
            return text;
        const parts = [];
        let last = 0;
        for (const [start, end] of ranges) {
            if (start > last)
                parts.push(text.slice(last, start));
            parts.push(m("b", null, text.slice(start, end + 1)));
            last = end + 1;
        }
        if (last < text.length)
            parts.push(text.slice(last));
        return parts;
    }
    getItemDisplay(item, matches) {
        const name = [
            this.highlightRanges(item[IDX.key], matches?.[0]),
            " - ",
            this.highlightRanges(item[IDX.geocode], matches?.[1]),
            item[IDX.disabled] ? ` (${getTextFixed("NOT_AVAILABLE_SHORT")})` : ""
        ];
        const summary = [item[IDX.type], item[IDX.wisselligger], item[IDX.hoekverhouding], item[IDX.profiel], item[IDX.boogstraal], item[IDX.smeerlozeConstructie]]
            .filter(Boolean)
            .map(x => getText(x, undefined, x))
            .join(" | ");
        return { name, summary };
    }
    view(v) {
        const { item, exact, matches, onclick, ondelete } = v.attrs;
        const { name, summary } = this.getItemDisplay(item, matches);
        return m("div", { className: cleanString("search-result-item", ondelete && "-removable") },
            m(Button, { onclick: onclick, title: item[IDX.geocode] },
                m("span", null,
                    m("span", null, name),
                    isZentrakResult(v.attrs.item[IDX.key], v.attrs.item[IDX.geocode]) && m("img", { className: "logo-zentrak", src: ZENTRAK_LOGO })),
                m("span", null, summary),
                exact && m("span", null,
                    getTextFixed("EXACT_MATCH"),
                    " ",
                    getTextFixed(exact),
                    ": ",
                    m("b", null, item[IDX[exact]]))),
            ondelete && m("button", { className: "remove-recent", title: getTextFixed("REMOVE_FROM_RECENT"), onclick: (e) => {
                    e.stopPropagation();
                    ondelete();
                } },
                m(Svg, { src: getAsset("icons/close.svg") })));
    }
}
export class Header extends MithrilTsxComponent {
    tooltip;
    prorailDialog;
    _searchListDialog;
    _prorail;
    _fuzzy;
    abortSearchPulse;
    createNormalizedState(item) {
        return {
            wissel: {
                wisselType: item[IDX.type] ?? "NORMAL_SWITCH:ANGLE=LEFT",
                wisselLigger: item[IDX.wisselligger] ?? "CONCRETE",
                hoekVerhouding: item[IDX.hoekverhouding] ?? "1_9",
                spoorStaafProfiel: item[IDX.profiel] ?? "54E1",
                boogStraal: item[IDX.boogstraal] ?? "195",
            },
            article: {},
            answer: {},
            prorailKey: item[IDX.key],
            prorailEquipmentId: item[IDX.equipmentId],
            smeerlozeConstructie: smMap[item[IDX.smeerlozeConstructie]] ?? "L_LUBRICANT_FREE_NONE",
            puntStukMateriaal: pmMap[item[IDX.afschrijvingsgroep]],
        };
    }
    getApplyThisDialogName(item) {
        return `${item[IDX.key]} - ${item[IDX.geocode]} ${item[IDX.disabled] ? ` (${getTextFixed("NOT_AVAILABLE_SHORT")})` : ""}`;
    }
    openApplyThisDialog(item, onApplied, options) {
        const name = this.getApplyThisDialogName(item);
        const readOnly = options?.readOnly ?? false;
        return dialog({
            title: options?.title ?? getTextFixed("APPLY_THIS", { type: item[IDX.type].startsWith("INTERSECTION") ? getTextFixed("CROSSING") : getTextFixed("SWITCH") }),
            className: "confirm-dialog search-list-dialog-inner",
            dismiss: readOnly,
            closeIcon: true
        }, _close => [
            ...railProContent(name, item),
            !readOnly && m("p", null, getTextFixed("WILL_OVERRIDE_CONFIGURATION")),
            !readOnly && m("div", { className: "dialog-footer" },
                m(Button, { text: getTextFixed("NOTIFY_PRORAIL_ISSUE"), className: "button-default", onclick: () => {
                        import('../notifyProrailIssue/notifyProrailIssue').then(x => x.notify(name, item));
                    } }),
                m("div", null,
                    m(Button, { text: getTextFixed("NO_CANCEL"), className: "button-ghost-default", onclick: () => {
                            _close();
                        } }),
                    m(Button, { text: getTextFixed("YES_APPLY"), className: "button-default", onclick: () => {
                            state.applyNormalizedUrlState(this.createNormalizedState(item), true);
                            addRecentSearch(item);
                            m.redraw();
                            _close();
                            onApplied?.();
                        } })))
        ], undefined, document.activeElement);
    }
    // async getProrailChoiceItem() {
    //   const prorail = state.getProrailChoice()
    //   if (!prorail)
    //     return
    //   this._prorail ??= import("../../state/data/prorail").then(x => x.loadItems())
    //   const source = await this._prorail
    //   return source.find(x => x[IDX.key] === prorail.key && x[IDX.equipmentId] === prorail.equipmentId)
    // }
    async applyItem(item, close) {
        if (item[IDX.disabled])
            return await dialog({
                title: getTextFixed("NOT_AVAILABLE"),
                className: "search-list-dialog-inner",
                closeIcon: true,
                dismiss: true,
            }, __close => [
                m("div", { className: "dialog-footer" },
                    m(Button, { text: getTextFixed("ok"), className: "button-default", onclick: () => __close("ok") }))
            ]).promise;
        await this.openApplyThisDialog(item, () => close()).promise;
    }
    searchListDialog = singleton(async (input) => {
        const term = input.value.trim();
        if (this._searchListDialog) {
            this._searchListDialog.term = term;
            return;
        }
        let results = [];
        let _searchedTerm;
        let loading = true;
        const search = throttle(500, async () => {
            const _term = this._searchListDialog?.term ?? term;
            if (_searchedTerm === _term)
                return;
            loading = true;
            _searchedTerm = _term;
            this._prorail ??= import("../../state/data/prorail").then(x => x.loadItems());
            const source = await this._prorail;
            const normalizedTerm = normalize(_term);
            const exactMatch = [];
            if (normalizedTerm.length > 0) {
                for (const x of source) {
                    if (normalize(x[IDX.tekeningnummer]) === normalizedTerm)
                        exactMatch.push({ item: x, exact: "tekeningnummer" });
                    else if (normalize(x[IDX.key]) === normalizedTerm)
                        exactMatch.push({ item: x, exact: "key" });
                    else if (normalize(x[IDX.geocode]) === normalizedTerm)
                        exactMatch.push({ item: x, exact: "geocode" });
                }
            }
            if (exactMatch.length > 0)
                results = exactMatch;
            else {
                this._fuzzy ??= createFuzzySearch(source, {
                    getText: x => [x[IDX.key], x[IDX.geocode]], // , x[IDX.tekeningnummer]
                    strategy: "smart"
                });
                // cap results: rendering (bolding matches) every hit is the main cost once the list is long
                results = _term.length < 2
                    ? []
                    : this._fuzzy(_term).slice(0, maxSearchResults);
                // .filter((x, i, a) => a.findIndex(y => y.item[IDX.key] === x.item[IDX.key]) === i)
            }
            loading = false;
            m.redraw();
        }, true);
        const el = document.querySelector(".configurator-header-actions > button:nth-child(1)");
        let recent = getRecentSearches();
        this._searchListDialog = {
            term,
            dialog: dialog({
                title: () => this._searchListDialog?.term ? getTextFixed("SEARCH_RESULTS_FOR", { term: this._searchListDialog.term }) : getTextFixed("RECENT_SEARCHES"),
                subtitle: () => this._searchListDialog?.term ? getTextFixed("SEARCH_RESULTS_DISCLAIMER") : undefined,
                className: "search-list-dialog",
                dismiss: true,
                closeIcon: true,
                backdrop: false,
                onopen: (ctx) => {
                    document.on("keydown.searchListDialog", e => {
                        if (e.key === "ArrowDown" || e.key === "ArrowUp" || e.key === "Tab") {
                            document.off("keydown.searchListDialog");
                            document.querySelector(".search-list-dialog .search-results")?.focus({ preventScroll: true });
                        }
                    });
                    this.searchInput?.parentElement?.classList.add("-open");
                    window.on("click.searchListDialog", ev => {
                        const root = ev.target.closest(".search-list-dialog") || ev.target.closest(".configurator-header-actions .search") || ev.target.closest(".search-list-dialog-inner");
                        if (!root)
                            ctx.close();
                    });
                },
                onclose: () => {
                    if (window.innerWidth < 640)
                        this.searchInput?.parentElement?.classList.remove("-open");
                    document.off("keydown.searchListDialog");
                    window.off("click.searchListDialog");
                },
                morph: () => {
                    appEl ??= document.querySelector(".oj-App");
                    const appHeight = appEl?.clientHeight ?? window.innerHeight;
                    const margin = 20;
                    const width = Math.min(partListDialogWidth, window.innerWidth - 64);
                    const height = Math.min(partListDialogHeight, appHeight - margin * 2);
                    const rect = getBoundingClientRectFrom(el);
                    return [{
                            x: rect.x,
                            y: rect.y,
                            width: rect.width,
                            height: rect.height
                        },
                        {
                            x: window.innerWidth - width - 32,
                            y: margin + 84,
                            width,
                            height: height - 84,
                        }
                    ];
                }
            }, _close => m("div", null,
                m("div", { className: "search-results", oninit: () => search(), onbeforeupdate: () => { search(); } }, this._searchListDialog?.term
                    ? loading
                        ? m("img", { className: "loading", src: getAsset("images/loading.gif") })
                        : results?.length > 0
                            ? results.map(x => m(ResultItem, { item: x.item, exact: x.exact, matches: x.matches, onclick: () => this.applyItem(x.item, _close) }))
                            : m("p", null, getTextFixed("NO_RESULTS_FOUND"))
                    : recent.length > 0
                        ? recent.map(item => m(ResultItem, { item: item, onclick: () => this.applyItem(item, _close), ondelete: () => {
                                removeRecentSearch(item[IDX.key], item[IDX.equipmentId]);
                                recent = getRecentSearches();
                                m.redraw();
                            } }))
                        : m("p", null, getTextFixed("NO_RECENT_SEARCHES")))), input)
        };
        this._searchListDialog.dialog.promise.finally(() => {
            document.off("keydown.searchListDialog");
            delete this._searchListDialog;
            delete this._fuzzy;
            delete this._prorail;
        });
    }, () => "");
    openTooltip = singleton(async () => {
        const summaryList = state.getSummaryList();
        const typeList = Object.keys(state.default);
        const labelList = ["SWITCH_TYPE", "SLEEPER_TYPE", "ANGLE_RATIO", "RAIL_PROFILE", "RADIUS"];
        this.tooltip = openTooltipDialog({
            selector: ".mobile-configuration-info",
            className: "mobile-configuration-info-tooltip",
            eventName: "MobileConfigurationInfoTooltip",
            rect: { width: 320, height: 220 },
            content: _close => (m("div", { className: "summary-container" },
                m("span", { className: "fs4" }, getTextFixed("CONFIGURATION")),
                summaryList.map((summary, index) => (m("button", { className: "summary-item", onclick: () => {
                        const type = typeList[index];
                        const tab = `base-option-${type}`;
                        const el = document.getElementById(tab);
                        if (el) {
                            el.focus({ preventScroll: true });
                            el.click();
                            el.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "nearest" });
                        }
                    } },
                    m("span", { className: "fs5" }, getText(labelList[index])),
                    m("span", { className: "fs5" }, summary)))))),
        });
        await this.tooltip.promise;
    });
    searchInput;
    view(v) {
        return (m("div", { className: cleanString("configurator-header", sharedProductUtils.dialogs.size > 0 && "dialog-open") },
            m("div", { className: "logo" },
                m("img", { src: getAsset("logo/logo-grijs.png") }),
                m("img", { className: "-zentrak", src: ZENTRAK_LOGO })),
            m("div", { className: "configurator-header-actions" },
                m(Button, { className: cleanString("button-white search", window.innerWidth >= 640 && "-open"), icon: "icons/search.svg", onclick: (e) => {
                        const input = e.currentTarget.querySelector("input");
                        input.focus({ preventScroll: true });
                        this.searchListDialog(input);
                    }, onpointerenter: (e) => {
                        e.currentTarget.querySelector("input").focus({ preventScroll: true });
                    }, oncreate: async ({ dom }) => {
                        if (this.abortSearchPulse)
                            return;
                        this.abortSearchPulse = new AbortController();
                        const signal = this.abortSearchPulse.signal;
                        while (!signal.aborted) {
                            await pause(1000).promise;
                            dom.classList.add("-search-highlight");
                            await pause(1000).promise;
                            dom.classList.remove("-search-highlight");
                        }
                    } },
                    m("input", { type: "text", placeholder: getTextFixed("SEARCH_IN_PRORAIL_DATABASE"), className: "search-input", oncreate: ({ dom }) => {
                            this.searchInput = dom;
                        }, oninput: (e) => {
                            this.abortSearchPulse?.abort();
                            this.searchListDialog(e.target);
                        }, onkeydown: (e) => {
                            if (e.key === "Enter")
                                this.searchListDialog(e.target);
                        }, onpointerenter: (e) => e.stopPropagation(), onclick: (e) => {
                            e.stopPropagation();
                            this.searchListDialog(e.target);
                        } })),
                m(Button, { className: "button-white", icon: "icons/lang.svg", onclick: async (e) => {
                        const btn = e.currentTarget.closest("button");
                        const rect = getBoundingClientRectFrom(btn);
                        const d = await dialog({
                            title: () => getTextFixed("SELECT_LANGUAGE"),
                            className: "language-select-dialog",
                            dismiss: true,
                            close: false,
                            morph: () => {
                                return [{
                                        x: rect.x - 50 - rect.width * .5,
                                        y: rect.y,
                                        width: 100,
                                        height: rect.height
                                    },
                                    {
                                        x: window.innerWidth - 240,
                                        y: 104,
                                        width: 200,
                                        height: 206,
                                    }
                                ];
                            }
                        }, _close => Object.keys(languages).map(lang => m(Button, { key: lang, text: getText(`LANGUAGE_${lang.toUpperCase()}`), onclick: () => {
                                const url = new URL(location.href);
                                url.searchParams.set("lang", lang);
                                history.pushState(null, "", url.href);
                                state.rebuild();
                                _close();
                            } }))).promise;
                    } })),
            m("button", { className: "mobile-configuration-info", onclick: () => {
                    this.openTooltip();
                } },
                m(Svg, { src: getAsset("icons/info2.svg") }))));
    }
    onbeforeupdate(v, o) {
        if (v.attrs.step !== o.attrs.step && v.attrs.step !== 0)
            this.prorailDialog?.close();
    }
    onremove() {
        this.tooltip?.close();
        this.prorailDialog?.close();
        window.off("pointermove.ProductTooltip");
    }
}
